import React from "react";
import { Button, Message } from "semantic-ui-react";
import { Modal } from "../../../components";

interface Props {
  documentId: number
  documentType: server.dto.DocumentTypes
  changeLifecycle: (documentType: server.dto.DocumentTypes, newLifecycle: server.dto.DocumentLifeCycles, documentId: number) => Promise<boolean>
  isOpen: boolean
  onClose: () => void
}

const StartNewVersionModal = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const onClick = async (e) => {
    e?.preventDefault();
    setIsLoading(true);

    try {
      const res = await props.changeLifecycle(props.documentType, "draft", props.documentId);
      if (!res) {
        setIsLoading(false);
      }
    } catch {
      window.displayGenericModalWithHtml(RESX.ExceptionMessage.ThereIsAProblem, RESX.ExceptionMessage.ThereWasAnError, "tiny");
      setIsLoading(false);
    }
  };
  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="tiny"
    title={RESX.GeneralWarnings.Warning}
  >
    <div className="grow1">
      <Message color="red">
        {RESX.ESign.StartNewVersionWarning}<br />
        <br />
        {(props.documentType === "contract" || props.documentType === "purchaseAgreement" || props.documentType === "quote") && <>{RESX.ESign.AllSignaturesWillBeRemovedWarning}<br /></>}
        <br />
        {RESX.ESign.ParticipantsCannotAccessDocumentUnderRevisionWarning}
      </Message>
    </div>

    <div className="flex justify-end margin-top-bigger">
      <Button loading={isLoading} disabled={isLoading} color="blue" onClick={onClick}>
        {RESX.ESign.StartNewVersion}
      </Button>
    </div>
  </Modal>;
};

export default StartNewVersionModal;